import React, {useState, useEffect, createRef} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import {Form, Button, Row, Col} from 'react-bootstrap';
import {createBook, updateBook} from '../../actions/book';
import { createRequest, updateRequest } from '../../actions/request';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

const Manualform = ({myrequests, currentId, setCurrentId}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [bookInfo, setBookInfo] = useState({name: '', author: '', condition: 'Brand New', subject: '', professor: '', notes: 'Present', exam: 'Present'});
  
  const ownerInformation = JSON.parse(localStorage.getItem('profile'));
  const ownerId = ownerInformation?.result._id;
  const info = window.location.href.split("/");
  const currentPage =  info[info.length - 1]; 
  const book = useSelector((state) => currentId ? state.mybooks.find((p) => p._id == currentId) : null);
  
  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  
  useEffect(() => {
      if(book) setBookInfo(book);
  }, [book]);

  const handleChange = (e) => {
    setBookInfo({...bookInfo, [e.target.name]: e.target.value});
  };

  const clearInfo = () =>{
    setBookInfo({name: '', author: '', condition: 'Brand New', subject: '', professor: '', notes: 'Present', exam: 'Present'});
    setCurrentId(0)
  }

  const handleSubmit = (event) =>{
    if (currentId == 0){
      event.preventDefault();
      if (currentPage === "mybooks"){
        const bookInformation = bookInfo;
        bookInformation.Owner = ownerId;
        dispatch(createBook(bookInformation));
      }
      else if (currentPage === 'myrequests'){
        const requestInformation = bookInfo;
        delete requestInformation["condition"];
        delete requestInformation["notes"];
        delete requestInformation["exam"];
        requestInformation.Owner = ownerId;
        dispatch(createRequest(requestInformation));
      }  
    }else{
      if (currentPage === "mybooks"){
        dispatch(updateBook(currentId, bookInfo));
      } else if (currentPage === "myrequests"){
        dispatch(updateRequest(currentId, bookInfo));
      }
    }
    setOpen(true);
    setCurrentId(0);
    clearInfo(); 
  };

  return (
        <div>
          {!currentId ? 
            <h1> Post a {currentPage === 'mybooks'?  <> Book </> : <> Request </> } </h1> :
            <h1> Edit a {currentPage === 'mybooks'?  <> Book </> : <> Request </> }</h1> 
          }
          <Form type = "submit">
            <Form.Group controlId="exampleForm.ControlInput1">
              <Form.Label>Name and Edition</Form.Label>
              <Form.Control onChange = {handleChange} name = "name" value = {bookInfo.name} />
            </Form.Group>
            <Form.Group controlId="exampleForm.ControlInput1">
              <Form.Label>Author's Name</Form.Label>
              <Form.Control onChange = {handleChange} name = "author" value = {bookInfo.author} />
            </Form.Group>
          {!myrequests &&
            <Form.Group controlId="exampleForm.ControlSelect1">
              <Form.Label>Condition</Form.Label>
              <Form.Control onChange = {handleChange} name = "condition" value = {bookInfo.condition} as="select">
                <option value = "Brand New">Brand New</option>
                <option value = "Like New">Like New</option>
                <option value = "Very Good">Very Good</option>
                <option value = "Good">Good</option>
                <option value = "Acceptable">Acceptable</option>
              </Form.Control>
            </Form.Group>
          } 
          <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
              <Alert onClose={handleClose} severity="success">
                Your {currentPage === 'mybooks'?  <> book </> : <> request </> } has been posted! 
              </Alert>
          </Snackbar>
          <Form>
            <Row>
              <Col>
                <Form.Group controlId="exampleForm.ControlInput1">
                  <Form.Label>Subject</Form.Label>
                  <Form.Control onChange = {handleChange} name = "subject" value = {bookInfo.subject} />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="exampleForm.ControlInput1">
                  <Form.Label>Professor's Name</Form.Label>
                  <Form.Control onChange = {handleChange} name = "professor" value = {bookInfo.professor} />
                </Form.Group>
              </Col>
            </Row>
          </Form>
          {!myrequests &&
          <Row>
            <Col>
              <Form.Group controlId="exampleForm.ControlSelect1">
              <Form.Label>Notes</Form.Label>
              <Form.Control as="select" value = {bookInfo.notes} name = "notes" onChange = {handleChange}>
                <option value = "Present">Present</option>
                <option value = "Absent">Absent</option>
              </Form.Control>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="exampleForm.ControlSelect1">
                <Form.Label>Exam Materials</Form.Label>
                <Form.Control onChange = {handleChange} as="select" name = "exam" value = {bookInfo.exam}>
                  <option value = "Present">Present</option>
                  <option value = "Absent">Absent</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          }
          <br />
          <Button onClick = {handleSubmit} variant="outline-primary">Submit</Button> &nbsp; &nbsp; {'  '}; 
          <Button onClick = {clearInfo} variant="outline-danger">Clear</Button>
        </Form>  
      </div>
  )
}

export default Manualform;
